module.exports = __webpack_public_path__ + "static/home_section2_icon2-76445b6de8637d2bf8ddd429ecd4388e.png";